<template>
    <information-popup modal-id="inscriptionGuidelinesPopup" v-bind:info="info">
        <template slot="header">Inscription Guidelines</template>
        <slot>
            <div class="modal-body">
                Your personalized message can be engraved with up to {{ info.max_chars }} characters per line, including blank spaces.
                A character is any letter, number, symbol or punctuation mark found on a standard English keyboard.
                All text will automatically be centered and engraved in UPPERCASE letters.
                Discriminatory, political, offensive or unsuitable messages as determined by Prosper ISD will be declined.
                Prosper ISD reserves the right to decline inscriptions for any reason.
                Should your inscription require revision, you will be contacted for assistance in submitting an alternative inscription.
            </div>
        </slot>
    </information-popup>
</template>

<script type="text/jsx">
    import InformationPopup from '@/components/popup/information-popup.vue';
    export default {
        name: 'inscription-guidelines',
        props: {
            info: {
                type: Object, // can be modified by child component
                required: false,
                default: function () {
                    return {
                        max_chars: 16 // minimal known value as default
                    };
                }
            }
        },
        components: {
            'information-popup': InformationPopup
        }
    }
</script>



// WEBPACK FOOTER //
// InscriptionGuidelines.vue?5c88b1dc